import {IDatabase} from 'src/services/database';
import {IPage} from 'src/services/pages';

export const format = (group: string, fieldName: string) =>
    `${formatGroup(group)}_${fieldName.toLowerCase()}`;
export const formatGroup = (group: string) => `${group.replace(/[\W_]+/g, '_')}`;

const getDbFieldForType = (database: IDatabase, type: string) =>
    database.fields.find((f) => {
        let extra: any = {};
        try {
            extra = JSON.parse(f.extra);
        } catch (ex) {}
        return extra.type === type;
    });

const getDbFieldForName = (database: IDatabase, name: string) =>
    database.fields.find((f) => {
        return f.name === name;
    });

const extractPageFieldKeyFromDatabaseField = (field, fallback) =>
    field ? `${`${field.group}`.replace(/[\s.]/g, '_').replace(/_+/g, '_')}_${field.name}` : fallback;

export const getSpecialPageFieldKeysForDatabase = (specialKeys:string[], database: IDatabase) => {
    const base = {
        title: extractPageFieldKeyFromDatabaseField(
            getDbFieldForName(database, 'page_title'),
            'General_Information_title'
        ),
        description: extractPageFieldKeyFromDatabaseField(
            getDbFieldForName(database, 'resource_description'),
            'General_Information_short_description'
        ),
    };
    specialKeys.forEach((k) => {
        base[k] = extractPageFieldKeyFromDatabaseField(getDbFieldForName(database, k), undefined);
    });
    return base;
}

export const getSepcialPageFieldKeysForDataabse = (database: IDatabase) => {
    const specialKeys = [
        'contact',
        'contactFirst',
        'contactLast',
        'number',
        'email',
        'link',
        'street',
        'city',
        'state',
        'zip',
        'map',
        'agesServed',
        'fees',
        'focusArea',
        'availableVirtually',
        'gradesServed',
        'servesSpecialNeeds',
        'programAvailability',
        'transportationAvailable',
        'mealsProvided',
        'programDates',
        'programDaysOfWeek',
        'programTimes',
    ];
    const base = {
        title: extractPageFieldKeyFromDatabaseField(
            getDbFieldForType(database, 'title'),
            'General_Information_title'
        ),
        description: extractPageFieldKeyFromDatabaseField(
            getDbFieldForType(database, 'description'),
            'General_Information_short_description'
        ),
    };
    specialKeys.forEach((k) => {
        base[k] = extractPageFieldKeyFromDatabaseField(getDbFieldForType(database, k), undefined);
    });
    return base;
};

const parseResult = (data: string) => {
    const output = JSON.parse(data);
    if (typeof output === 'string' || Array.isArray(output)) return output;
    else return data;
};

export const getFormattedPageData = (page: IPage, database: IDatabase) => {
    const mappedData = {};
    Object.keys(page.row.map).forEach((fieldKey) => {
        const dbField = database.fields.find(
            (field) => format(field.group, field.name) === fieldKey
        );
        if (dbField) {
            const value = parseResult(page.row.map[fieldKey]);
            mappedData[fieldKey] = {
                label: dbField.label,
                value,
                key: fieldKey,
                lines: Array.isArray(value) ? value.length : 1,
                dbField,
            };
        }
    });
    return mappedData;
};



// WEBPACK FOOTER //
// ./src/helpers/pages.ts